import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { UnauthorizedPage, NotFoundPage } from '../components/errors';
import HomePage from '../components/pages/HomePage';
import LoginPage from '../modules/login/LoginPage';
import AuthenticatedRoute from '../routes/AuthenticatedRoute';
import GuestRoute from '../routes/GuestRoute';
import { RoutePath } from '../routes/RoutePath';

export default class Routes extends React.Component {

    render() {
        return (
            <Switch>
                <AuthenticatedRoute exact={true} path={RoutePath.HomePage} component={HomePage} />
                <GuestRoute exact={true} path={RoutePath.Login} component={LoginPage} />
                <Route exact={true} path={RoutePath.Unauthorized} component={UnauthorizedPage} />
                <Route component={NotFoundPage} />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/routes/Routes.tsx